import React, { useState } from 'react';
import './footersection.css';
import { FaFacebook, FaInstagram, FaYoutube, FaLinkedin, FaPhone, FaEnvelope } from 'react-icons/fa';
import { FaXTwitter } from "react-icons/fa6";
import Appstore from '../../../assets/images/App Store.png';
import Googleplay from '../../../assets/images/Google Play.png';
import logo from '../../../assets/images/Footbar_LeaderlyLogo.png';
import { ClientPreLoginService } from '../../../services/clientPreLoginService';

const Footersection = () => {
  const handleNavigation = (path, section) => {
    if (!sessionStorage.getItem("initialScrollPosition")) {
      sessionStorage.setItem("initialScrollPosition", window.scrollY);
    }
    sessionStorage.setItem("scrollPosition", window.scrollY);
    window.location.href = `${path}?section=${section}`;
  };

  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

  const handleSubscribe = async () => {
    if (!email.trim()) {
      setErrorMessage("Email is required");
      return;
    }

    if (!emailPattern.test(email)) {
      setErrorMessage("Enter a valid email address");
      return;
    }

    try {
      await ClientPreLoginService.subscribe(email);
      setErrorMessage("Subscription successful!");
      setEmail('');
    } catch (error) {
      setErrorMessage("Subscription failed. Please try again later.");
      console.error("Subscription error:", error);
    }
  };

  return (
    <div className="fluid-container">
      <div className="footer-wrapper">
        <div className="footer">
          <div className="footer-top">
            <div className="footer-logo">
              <img src={logo} alt="logo" />
              <p >India’s 1<sup>st</sup> <span className='footer-logo-span'>exclusive platform for discovering leaders</span></p>
            </div>
            <div className="footer-subscribe">
              <input
                type="email"
                placeholder="XYZ@gmail.com"
                spellCheck="false"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button onClick={handleSubscribe}>Subscribe</button>
            </div>
            {errorMessage && (
              <div className="login-alert-overlay">
                <div className="login-alert-box">
                  <div className="login-alert-content">
                    <p>{errorMessage}</p>
                    <button className="login-alert-button" onClick={() => setErrorMessage('')}>
                      OK
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="footer-middle">
            <div className="footer-links">
              <div className="footer-column">
                <h4>Resource</h4>
                <ul>
                  <li>
                    <a onClick={() => handleNavigation("/resources-blog")}>Blog</a>
                  </li>
                  <li>
                    <a onClick={() => handleNavigation("/navbar-faq")}>FAQ</a>
                  </li>
                  {/* <li>
                  <a onClick={() => handleNavigation("/videos")}>Videos</a>
                  </li> */}
                </ul>
              </div>
              <div className="footer-column">
                <h4>Company</h4>
                <ul>
                  <li>
                    <a onClick={() => handleNavigation("/about-us")}>About us</a>
                  </li>
                  <li>
                    <a onClick={() => handleNavigation("/pricing-prelogin")}>Pricing</a>
                  </li>
                  <li>
                    <a onClick={() => handleNavigation("/contact-us")}>Contact us</a>
                  </li>

                </ul>
              </div>
              <div className="footer-column">
                <h4>Policies</h4>
                <ul>
                  <li>
                    <a onClick={() => handleNavigation("/policy", "privacy")}>Privacy Policy</a>
                  </li>
                  <li>
                    <a onClick={() => handleNavigation("/policy", "terms")}>Terms of Use</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="footer-vertical-line"></div>
            <div className="footer-app">
              <h4>Download app</h4>
              <div className="app-buttons">
                <a href="#">
                  <img src={Appstore} alt="Download on the App Store" />
                </a>
                <a href="#">
                  <img src={Googleplay} alt="Get it on Google Play" />
                </a>
              </div>
              <h4>Reach Us</h4>
              <div className="footer-contact">
                <p>
                  <FaPhone /> +91 7738333452
                </p>
                <p>
                  <FaEnvelope /> sales@leaderly.in
                </p>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p>© 2026 Signite Technology Pvt Ltd. All rights reserved.</p>
            <div className="social-icons">
              <a
                href="https://www.facebook.com/LeaderlyOfficial/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook />
              </a>
              <a
                href="https://x.com/LeaderlyIndia/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaXTwitter />
              </a>
              <a
                href="https://www.instagram.com/leaderlyofficial/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.linkedin.com/company/leaderlyofficial/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footersection;